import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from '../../styles/FormSelectInput.module.scss';

const cx = classNames.bind(styles);

const EnrollmentFormSelectInput = ({
  name,
  label,
  placeholder,
  defaultValue,
  error,
  inputRef,
  required,
  children,
  onChange,
}) => {
  return (
    <>
      <label htmlFor={name} className="labelText">
        {label}
        {required && <em> *</em>}
      </label>
      <select
        id={name}
        name={name}
        className={cx('EnrollmentFormSelectInput', { error })}
        defaultValue={defaultValue}
        ref={inputRef}
        required
        onChange={onChange}
      >
        <option disabled hidden value="">
          {placeholder}
        </option>
        {children}
      </select>
    </>
  );
};

EnrollmentFormSelectInput.defaultProps = {
  placeholder: 'Please select...',
  defaultValue: '',
  error: null,
  required: false,
  onChange: null,
};

const errorShape = PropTypes.shape({
  type: PropTypes.string.isRequired,
  message: PropTypes.string,
});

EnrollmentFormSelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  defaultValue: PropTypes.string,
  error: errorShape,
  inputRef: PropTypes.func.isRequired,
  required: PropTypes.bool,
  children: PropTypes.node.isRequired,
  onChange: PropTypes.func,
};

export default EnrollmentFormSelectInput;
